import Head from 'next/head'
import Image from 'next/image'
import { Inter } from 'next/font/google'
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import NextLink from 'next/link';
import { useUser, useSupabaseClient } from '@supabase/auth-helpers-react';
import FaqBlock from '../../components/faqblock';

const inter = Inter({ subsets: ['latin'] })

export default function Home() {
  const user = useUser();

  return (
    <>
    <Head>
      <title>Contact & FAQ Page | StyleSense.io</title>
      <meta
        name="description"
        content="Answers to our users' most frequently asked questions. If you have any questions or feedback, please email support."
        key="desc"
      />
    </Head>     
    <main className="min-h-screen max-w-full overflow-x-hidden box-border flex flex-col justify-between items-center">
      <Navbar />      
      <section class="py-8">
        <div class="mx-auto max-w-full overflow-x-hidden box-border px-4 sm:px-6 lg:px-8">
            <div class="md:mx-10 bg-white  dark:bg-white/50 rounded py-10 px-5 flex flex-col justify-between gap-12 lg:flex-row lg:items-stretch">
                <div class="flex flex-col">
                    <div class="flex-1 md:min-w-[400px]">
                        <h2 class="text-3xl font-bold text-gray-800 font-title sm:text-4xl">Contact Us</h2> 
                        <p class="mt-4 text-base font-normal text-gray-500 dark:text-gray-700">Estimated response time: 1-3 business days.</p>
                        <div className="bg-gray-50 dark:bg-gray-50/50 p-3 rounded w-fit my-2">
                            <p class="text-gray-500 text-sm text-left w-full mt-2"><a href="mailto:support@stylesense.io" class="underline text-blue-500">Email support</a> if you have any questions or get stuck</p>
                            <p class="text-gray-500 text-sm text-left w-full mt-2"><NextLink className="text-blue-500 underline" href="https://www.reddit.com/r/stylesense/">Join the community</NextLink> if you have feedback or feature requests</p>
                        </div>
                    </div>
                </div>                 
                <FaqBlock title={true}/>
            </div>
        </div>
      </section>  
      <Footer />
    </main>
    </>
  )
}